import React from 'react';
import './ServiceDetail.css';
import SubpagesLink from './SubpagesLink';
import TestimonialSection from './TestimonialSection';
import serviceImage from '../assets/service1.png';
import ndisLogo from '../assets/ramp-icon-update.png';
import SkewedContainer from 'sc-react';
import { Helmet } from 'react-helmet';
import SignupForm from './utils/SignupForm';
import { Link } from 'react-router-dom';
import HealthSection from './utils/HealthSection';

const EffectiveGymWorkoutsForBusyProfessionals = () => {
    return (
        <div>
            <Helmet>
                <title>Effective Gym Workouts for Busy Professionals | Ramp Physio and Fitness</title>
            </Helmet>
            <div className="service-detail-content">
                <div className="service-detail-text">
                    <br></br><br></br>
                    <h1>Maximize Your Fitness</h1>
                    <h2>Unlock the secrets to effective gym workouts tailored for busy professionals at Ramp Physio and Fitness, and propel your fitness journey forward with our expert guidance and state-of-the-art facilities in Homebush, NSW.</h2>
                    <p>For busy professionals, finding time for gym workouts can be a challenge. At Ramp Physio and Fitness, we understand the value of your time and have designed a range of effective gym workouts that fit into your hectic schedule. These workouts are not only efficient but also ensure you achieve your health and fitness goals without sacrificing your professional responsibilities. In this article, we'll explore how you can maximize your workout regime, even with a busy lifestyle.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
                <div className="service-detail-image-container">
                    <img src={serviceImage} alt="Service Detail" className="service-detail-image" />
                </div>
            </div>
            <SkewedContainer top="left" bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container1">
                    <div className="service-intro-content1">
                        <h1>Quick Full-Body Routines</h1>
                        <p>Engage in our specially curated full-body workout routines that are quick yet comprehensive, targeting all major muscle groups for maximum efficiency. With exercises like compound lifts and high-intensity interval training (HIIT), you can get a complete workout in under an hour. Here's how you can make the most of your limited gym time:</p>
                        <ul>
                            <li>Focus on compound movements such as squats, deadlifts, and bench presses.</li>
                            <li>Incorporate HIIT for cardio that also helps build muscle.</li>
                            <li>Utilize supersets to work on opposing muscle groups without rest.</li>
                        </ul>
                    </div>
                    <div className="intro-image">
                        <img src="../assets/bike.webp" alt="Exercise" />
                    </div>
                </div>
            </SkewedContainer>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/massage.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Strategic Workout Planning</h1>
                    <p>Strategically plan your workouts to align with your busy schedule. By prioritizing your fitness goals and adopting a structured approach, you can make each session count. Here are strategies to help you:</p>
                    <ul>
                        <li>Plan your workouts at the beginning of the week.</li>
                        <li>Set clear, achievable objectives for each session.</li>
                        <li>Choose time-efficient workouts like circuit training.</li>
                    </ul>
                </div>
            </div>
            <SkewedContainer bottom="left" bgColor="white" noMargin>
                <div className="service-intro-container3">
                    <img src={ndisLogo} alt="NDIS Logo" className="service-intro-logo" />
                    <p className="service-intro-text">
                        Ramp Physio and Fitness
                    </p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="servicedetail-book-now"
                        onClick={() => {
                          window.gtag_report_conversion('https://docs.google.com/forms/d/e/1FAIpQLSf-SNK-w_xwsp3QPzQGLmvpbNB_dmG5Khx6kfXMejLNMmJoYg/viewform?pli=1');
                        }}>
                        Book Now
                    </a>
                </div>
            </SkewedContainer>
            
            <div className="service-intro-container4">
                <div className="service-intro-content4">
                    <h1>Technology-Enhanced Training</h1>
                    <p>Embrace the power of technology to optimize your gym sessions. At Ramp Physio and Fitness, we leverage cutting-edge tools and apps that help you track progress, maintain consistency, and stay motivated. Consider using:</p>
                    <ul>
                        <li>Fitness trackers to monitor your activity levels.</li>
                        <li>Workout apps for guided exercise routines.</li>
                        <li>Online platforms for remote coaching and support.</li>
                    </ul>
                </div>
                <div className="intro-image">
                    <img src="../assets/bike.webp" alt="Exercise" />
                </div>
            </div>
            <SkewedContainer top="left" bgColor="#2980b9" noMargin>
            <div className="service-intro-container2">
                <div className="intro-image">
                    <img src="../assets/Gymfloor1.webp" alt="Exercise" />
                </div>
                <div className="service-intro-content2">
                    <h1>Efficient Time Management</h1>
                    <p>Managing your time effectively is crucial when you're a busy professional. At Ramp Physio and Fitness, we help you streamline your workout process with tips and tricks that save time without compromising on quality. Here are some time-management strategies:</p>
                    <ul>
                        <li>Prepare your gym bag and outfit the night before.</li>
                        <li>Choose a gym close to your office or home.</li>
                        <li>Opt for shorter, more intense workouts over longer, less efficient ones.</li>
                    </ul>
                    <br></br>
                    <p>
                        In conclusion, even with a demanding schedule, you can still maintain an effective gym workout routine. At Ramp Physio and Fitness, we're dedicated to providing busy professionals like you with the tools, guidance, and support needed to stay fit and healthy. Let us help you achieve your fitness goals while balancing your professional life. Join our community and experience the benefits of a tailored fitness plan designed for your busy lifestyle.
                    </p>
                </div>
            </div>
            </SkewedContainer>
            
    <SubpagesLink />
    <HealthSection />
            <TestimonialSection />
        </div>
    );
};

export default EffectiveGymWorkoutsForBusyProfessionals;